
import {Component, Vue} from 'vue-property-decorator';
import DynamicTable from '@/components/datatables/DynamicTable.vue';
import {dispatchDeleteFormBatch, dispatchGetFormBatches, dispatchGetFormsValuesByQuery} from '@/store/main/actions';
import {readFormBatches, readHasModuleAccess} from '@/store/main/getters';
import DynamicTableSimpleAsync from '@/components/datatables/DynamicTableSimpleAsync.vue';

@Component({
  components: {DynamicTableSimpleAsync},
})
export default class FormBathList extends Vue {

  public headers = [
    // router_name: 'main-admin-forms_search_engines-edit'
    {
      text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-form-batch-edit', width: '100px', delete_function: this.deleteFunction,
    },

    {
      text: this.$t('registered-data'),
      value: 'registered_values',
      sortable: false,
      align: 'left',
      width: 200,
      type: 'array',
    },
    {text: this.$t('detail'), value: 'show_registered_batch', sortable: false, align: 'center'},
    {text: this.$t('released_batch'), value: 'released_batch', sortable: false, align: 'center'},
    {text: this.$t('quantity_requested'), value: 'quantity_requested', sortable: true, align: 'right'},
    {text: this.$t('created_at'), value: 'created_at', sortable: true, align: 'left', type: 'date'},
    {text: this.$t('origin_request'), value: 'origin_request', sortable: true, align: 'left'},
    {text: this.$t('requester'), value: 'requester', sortable: false, align: 'left', object_key: 'fullname'},
  ];

  public headersRemained = [
    {text: this.$t('observations'), value: 'observation', sortable: false, align: 'left'},
    {text: this.$t('observations_admin'), value: 'observation_admin', sortable: false, align: 'left'},
  ];

  private numberOfPages: number = 0;
  private totalItems: number = 0;

  public async mounted() {
    // const response = await dispatchGetFormBatches(this.$store, {with_stats: false, skip: 0, limit: 10});
  }

  public async loadDataAPI(payload: any) {
    payload.with_stats = false;
    const response = await dispatchGetFormBatches(this.$store, payload);

    if (response) {
      this.totalItems = response.data.total_items;
      this.numberOfPages = response.data.total_items_page;
    }
  }

  private async deleteFunction(id) {
    await dispatchDeleteFormBatch(this.$store, id);
    await dispatchGetFormBatches(this.$store, {with_stats: false, skip: 0, limit: 10});
  }


  private get formBatchesRequest() {
    return readFormBatches(this.$store);
  }

  private get hasAccess() {
    return readHasModuleAccess(this.$store)({module: 'form_batch_request_admin', method: 'list'});
  }
}
